import { dbApi, getApiErrorMessage } from "@/lib/api"
import type {
  CompleteOrgInviteRequest,
  CompleteOrgInviteResponse,
  OrgInviteDetails,
} from "@/types/orgInvite"

export async function fetchOrgInviteDetails(
  token: string
): Promise<{ ok: true; details: OrgInviteDetails } | { ok: false; error: string }> {
  try {
    const { data } = await dbApi.get<OrgInviteDetails>("/api/auth/org-invite", {
      params: { token },
    })
    return { ok: true, details: data }
  } catch (e) {
    return { ok: false, error: getApiErrorMessage(e) }
  }
}

export async function completeOrgInvite(
  payload: CompleteOrgInviteRequest
): Promise<
  | { ok: true; data: CompleteOrgInviteResponse }
  | { ok: false; error: string }
> {
  try {
    const { data } = await dbApi.post<CompleteOrgInviteResponse>(
      "/api/auth/org-invite/complete",
      payload
    )
    return { ok: true, data }
  } catch (e) {
    return { ok: false, error: getApiErrorMessage(e) }
  }
}
